import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BulkSelectPayrollEmployeeDialogComponent } from '@app/components/dialogs/bulk-select-payroll-employee-dialog/bulk-select-payroll-employee-dialog.component';
import { WorkersCompensationAssignedEmployee } from '@app/models/payroll/workers-compensation-assigned-employee.model';
import { WorkersCompensation } from '@app/models/payroll/workers-compensation.model';
import { EmployeeWorkersCompensationTable } from '@app/modules/payroll/services/tables/employee-workers-compensation-table/employee-workers-compensation.table';
import { WorkersCompensationService } from '@app/modules/payroll/services/workers-compensation.service';
import { AuthService, NotifyService } from '@app/services';

@Component({
    templateUrl: './workers-compensation-show.template.html',
})
export class WorkersCompensationShowView implements OnInit {
    @ViewChild('selectEmployees', { static: true }) selectEmployees!: BulkSelectPayrollEmployeeDialogComponent;

    isLoading = false;
    table: EmployeeWorkersCompensationTable;
    title = 'payroll.workers-compensation.editTitle';
    workersCompensation: WorkersCompensation;
    displayEditModal = false;
    selectedEmployees: WorkersCompensationAssignedEmployee[] = [];
    attach: number[] = [];
    detach: number[] = [];

    constructor(
        private auth: AuthService,
        public route: ActivatedRoute,
        private notify: NotifyService,
        private workersCompensationService: WorkersCompensationService
    ) {
        this.workersCompensation = this.route.snapshot.data.models.get('workersCompensation');
        this.table = new EmployeeWorkersCompensationTable(this.auth, this.workersCompensation.id);
    }

    async ngOnInit(): Promise<void> {
        this.isLoading = false;
    }

    getBackRoute(): string[] {
        return ['/payroll', 'workers-compensations'];
    }

    displayModal(shouldDisplayModal: boolean): void {
        this.displayEditModal = shouldDisplayModal;
    }

    async onSave(): Promise<void> {
        try {
            this.isLoading = true;

            await this.workersCompensation.param('company', this.auth.company?.id).save();

            this.notify.success('payroll.workers-compensation.saved');
            this.displayEditModal = false;
            this.isLoading = false;
        } catch (err) {
            this.isLoading = false;
            this.notify.error(err);
        }
    }

    async onAssign(): Promise<void> {
        const [assignedEmployees] = await WorkersCompensationAssignedEmployee.param('company', this.auth.company?.id)
            .param('workersCompensation', this.workersCompensation.id)
            .where('status', ['active', 'terminated', 'on leave'])
            .where('isWcbExempt', false)
            .with(['job', 'department'])
            .all();

        await this.selectEmployees
            .show<WorkersCompensationAssignedEmployee[]>([...assignedEmployees])
            .then((selected: WorkersCompensationAssignedEmployee[]) => {
                this.selectedEmployees = selected;
                const attach = selected
                    .filter((e: WorkersCompensationAssignedEmployee) => {
                        return !assignedEmployees.includes(e);
                    })
                    .map((e: WorkersCompensationAssignedEmployee) => e.prEmployeeId);

                const detach = assignedEmployees
                    .filter((e: WorkersCompensationAssignedEmployee) => {
                        return !selected.includes(e);
                    })
                    .map((e: WorkersCompensationAssignedEmployee) => e.prEmployeeId);

                this.attach = attach;
                this.detach = detach;

                if (this.selectedEmployees) {
                    this.selectEmployees.selectItems = this.selectedEmployees;
                    this.selectEmployees.selection = this.selectedEmployees;
                }
            });

        this.isLoading = true;
        try {
            await this.workersCompensationService.attachDetachEmployees(
                this.workersCompensation,
                this.attach,
                this.detach
            );
        } catch (error) {
            this.notify.error(error);
        }

        this.table.reload();
        this.isLoading = false;
    }
}
